import styled from 'styled-components';

export const StyledResultTextarea = styled.textarea`
   width: 100%;
   min-height: 120px;
   max-height: 300px;
   padding: 12px;
   border: 1px solid ${(props) => props.theme.borderLighter};
   border-radius: 8px;
   background-color: ${(props) => props.theme.backgroundBody};
   color: ${(props) => props.theme.textBody};
   font-size: 13px;
   font-family: inherit;
   line-height: 1.5;
   resize: vertical;
   box-sizing: border-box;

   &:focus {
      outline: none;
      border-color: ${(props) => props.theme.borderDark};
   }
`;

StyledResultTextarea.displayName = 'StyledResultTextarea';
